export default "<div class=\"b-caller__no_res\">\n    Совпадений нет\n</div>";